import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import Scrollspy from 'react-scrollspy'
import './navbar.css';

const Navbar = () => {

    const navRef = useRef<HTMLDivElement | null>(null);
    const [navHeight, setNavHeight] = useState<number>(56);

    useEffect(() => {
        const element = navRef.current;
        if (!element) return;

        const update = () => {
            const height = Math.round(element.getBoundingClientRect().height);
            if (height > 0) {
                setNavHeight(height);
                document.documentElement.style.setProperty('--nav-offset', `${height + 0}px`);
            }
        };

        update();

        if (typeof ResizeObserver !== 'undefined') {
            const ro = new ResizeObserver(() => update());
            ro.observe(element);
            return () => ro.disconnect();
        }

        window.addEventListener('resize', update);
        return () => window.removeEventListener('resize', update);
    }, []);

    const scrollSpyOffset = useMemo(() => -(navHeight + 8), [navHeight]);

    return (
        <div className="navBar" ref={navRef}>
            <Scrollspy items={['home', 'therapies', 'aboutMe', 'booking', 'maps', 'contact']} currentClassName="active" offset={scrollSpyOffset}>
                <li>
                    <Link
                        to='/#page-home'>
                        Start
                    </Link>
                </li>
                <li>
                    <Link
                        to="/#page-therapies">
                        Therapien
                    </Link>
                </li>
                <li>
                    <Link
                        to="/#page-aboutMe">
                        Über mich
                    </Link>
                </li>
                <li>
                    <Link
                        to="/#page-booking">
                        Termin
                    </Link>
                </li>
                <li>
                    <Link
                        to="/#page-maps">
                        Anfahrt
                    </Link>
                </li>
                <li>
                    <Link
                        to="/#page-contact">
                        Kontakt
                    </Link>
                </li>
            </Scrollspy>
        </div>
    );
};
export default Navbar;